<template>
	<template v-if="!loading && !error">
		<template v-for="section in sections" :key="section.slug">
			<section class="dk-realestate-section" v-if="section.visible">
				<h2 class="dk-realestate-section__title">
					Case e appartamenti in {{ section.title }}
				</h2>
				<GallerySection
					:slug="section.slug"
					:contract="section.guid"
					:municipality="municipality"
					:hamlet="hamlet"
					@propertiesUpdated="sectionUpdate"
				/>
			</section>
		</template>
	</template>
	<p v-if="loading">Caricamento...</p>
	<!-- <p v-if="error">Errore!<br />{{ error }}</p> -->
</template>

<script setup>
import {ref, onMounted} from 'vue'
import GallerySection from '~/default/vue/realestate/RealEstateGallerySection.vue'
import {getRealEstateGUIDs} from '~/default/vue/realestate/realestate'
import {getPropertiesDetails} from '~/default/vue/realestate/realestate-api'

const guids = getRealEstateGUIDs()
const loading = ref(true)
const error = ref(false)
const municipality = ref(null)
const hamlet = ref(null)
const sections = ref([
	{
		slug: 'rent',
		title: 'Affitto',
		guid: guids.rent,
		visible: true,
	},
	{
		slug: 'touristRental',
		title: 'Affitto turistico',
		guid: guids.touristRental,
		visible: true,
	},
	{
		slug: 'sale',
		title: 'Vendita',
		guid: guids.sale,
		visible: true,
	},
])

const sectionUpdate = (slug, propertiesCount) => {
	sections.value.find(x => x.slug === slug).visible = propertiesCount > 0
}

onMounted(async () => {
	loading.value = true

	const urlSlug = window.location.pathname.split('/')[3]
	const req = await getPropertiesDetails()

	if (!req.success) {
		error.value = req.error
		loading.value = false
		return
	}

	const findMunicitipality = req.data.locationMunicipalities?.find(x => x.slug === urlSlug)
	const findHamlet = req.data.locationHamlets?.find(
		x => x.slug === urlSlug.replace('frazione_di_', '')
	)

	if (findMunicitipality) {
		municipality.value = findMunicitipality.id
	} else if (findHamlet) {
		hamlet.value = findHamlet.id
	} else {
		error.value = 'Municipality o Hamlet non trovato in details (nessun immobile)!'
	}

	loading.value = false
})
</script>
